import moment from 'moment-wrapper';

function getNextDate (date, granularity) {
  const current = moment(date);
  let nextDate;
  switch (granularity) {
  case 'day':
    nextDate = current.add(1, 'day');
    break;
  case 'week':
    nextDate = current.add(1, 'week');
    break;
  case 'month':
    nextDate = current.add(1, 'month');
    break;
  case 'quarter':
    nextDate = current.add(1, 'quarter');
    break;
  case 'year':
    nextDate = current.add(1, 'year');
    break;
  default:
    nextDate = current.add(1, 'day');
    break;
  }

  return nextDate.toDate();
}

export default function getDateRange (fromDate, toDate, granularity = 'day') {
  const rangeList = [];
  let date = fromDate;
  while (date <= toDate) {
    rangeList.push(date);
    date = getNextDate(date, granularity);
  }
  return rangeList;
}
